module.exports = __webpack_public_path__ + "static/FuturaBTBook-6d5d928fead9dc80dda6b53077846921.woff2";